// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xh_a bhk_vn bhk_vf bhk_xb bhk_re bhk_tp bhk_qv"};